module.exports = __webpack_public_path__ + "static/img/qb.a5c2e1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ng/qb.png
// module id = jlgQ
// module chunks = 1